import React from "react";

import { faCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import styles from "./css/OnAirIcon.module.css";

export default function OnAirIcon({ className }: { className?: string }) {
	return (
		<span className={cx("fa-layers fa-fw", className)}>
			<FontAwesomeIcon icon={faCircle} fixedWidth className={styles.outerCircle} />
			<FontAwesomeIcon icon={faCircle} fixedWidth className={styles.innerCircle} />
		</span>
	);
}
